import { FormationModel } from './formation.model';
import { FormationProgrammeModel } from './formationProgramme.model';

export class FormFormationModel {
  formation: FormationModel = new FormationModel();
  formationProgramme: FormationProgrammeModel = new FormationProgrammeModel();
}
